import { IntlShape } from 'react-intl';

import { Typography } from '@mui/material';
import { ProviderPortalTranslationsApiClient } from '@provider-portal/common/api/gen/ProviderPortalTranslationsApiClient';
import config from '@provider-portal/common/config';
import type { Nullable } from '@provider-portal/common/types/types';
import { LanguageUtils } from '@provider-portal/common/utils/translations';
import { LocaleType } from '@provider-portal/common/utils/translations_types';

import defaultTranslations from '../../translations/source/translations.json';

export { LocaleType };

// eslint-disable-next-line @typescript-eslint/no-require-imports
const { initializeTranslationsService, Scope } = require('@bolteu/translations-service');

let currentAppLocale = LanguageUtils.getAppLocaleWithFallback();
export const getAppLocale = (): LocaleType => {
  return currentAppLocale;
};

const translationService = initializeTranslationsService({
  scope: Scope.foodhub,
  locale: currentAppLocale,
  fallbackLocale: LanguageUtils.getDefaultLocale(),
  fallbackTranslations: { [LanguageUtils.getDefaultLocale()]: defaultTranslations },
  TextComponent: Typography,
  apiClient: new ProviderPortalTranslationsApiClient(config.translationApiClientHost.toString()),
});

const updateServiceLocale = async () => {
  await translationService.setLocale(currentAppLocale);
};

updateServiceLocale();

export const setAppLocale = async (locale: LocaleType, reload = false) => {
  const isSetLocaleSuccessful = LanguageUtils.setLocale(locale);
  if (isSetLocaleSuccessful) {
    currentAppLocale = locale;
    try {
      await updateServiceLocale();

      if (reload) {
        window.location.reload();
      }
      return true;
    } catch (_e) {
      return false;
    }
  }
  return isSetLocaleSuccessful;
};

export const { RemoteIntlProvider } = translationService;

// small hack to be able to use translations in epics(redux-observable)
let globalIntl: Nullable<IntlShape> = null;
export const setGlobalIntl = (intl: IntlShape) => {
  globalIntl = intl;
};
export const getGlobalIntl = () => globalIntl;
